export default __webpack_public_path__ + "static/media/cook-time.494f8694.svg";